export default __webpack_public_path__ + "static/kevin-18d9162d4a6e83b52e3efa7e14fe53b9.jpg";